import { environment } from "../../../environment";
export const transitionsUrl = () => environment() === "PROD"
    ? `https://middleware.prod.farther.com/advisor-transition`
    : `https://middleware.uat.farther.com/advisor-transition`;
export const transitionUrl = (advisorTransitionId) => `${transitionsUrl()}/${advisorTransitionId}`;
//# sourceMappingURL=urls.js.map